import React, { useState, useEffect } from 'react';
import Crud_Catalogos from '../herramientas/Crud_Catalogos';
import { Button, Card, Alert } from 'tabler-react';
import { TablePageable } from '../Helpers';
import DetalleAlerta from './DetalleAlerta';
import ModalLayout from './ModalLayout.react';

const ListarAlertasPorCategoriaDeMovimiento = ({
  idmovimiento, 
  categoria, 
  idAlertaCategoriaDesvioRuta, 
  idAlertaCategoriaGpsSinSenal, 
  idAlertaCategoriaUnidadDetenida, 
  movimiento, 
  idusuario,
  onAlertaAtendida // Nueva prop para notificar que se atendió una alerta
}) => {
  //console.log(movimiento);
  const [listaAlertas, setListaAlertas] = useState([]);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const [loading, setLoading] = useState(true);

  // Función para obtener el endpoint correcto
  const getEndpoint = () => {
    // Base URL para todas las categorías
    const baseUrl = "navierasAlertas/listaAlertasPorMovimientoIdAlertaCategoriaUsuario/";
    
    if (categoria === "Desvío de ruta") {
      return `${baseUrl}${idusuario}/${idAlertaCategoriaDesvioRuta}/${idmovimiento}`;
    } else if (categoria === "GPS sin señal") {
      return `${baseUrl}${idusuario}/${idAlertaCategoriaGpsSinSenal}/${idmovimiento}`;
    } else if (categoria === "Unidad detenida") {
      return `${baseUrl}${idusuario}/${idAlertaCategoriaUnidadDetenida}/${idmovimiento}`;
    }
    
    // Si no coincide ninguna categoría
    console.warn(`Categoría no reconocida: ${categoria}`);
    return null;
  };

  // Función para listar alertas
  const listar = () => {
    setLoading(true);
    setMostrarMensaje(false);
    
    const endpoint = getEndpoint();
    //console.log("Endpoint a llamar:", endpoint); // Depuración
    
    if (!endpoint) {
      console.error("No se pudo determinar el endpoint para la categoría:", categoria);
      setLoading(false);
      setMostrarMensaje(true);
      return;
    }
    
    crud("get", "", "", endpoint, "listaAlertasMovimientoAlertaCategoria");
  };

  // Función para atender alerta
  const atenderAlertaNaviera = (idAlerta, idUsuario) => {
    //console.log(`Atendiendo alerta: ${idAlerta} por usuario: ${idUsuario}`);
    crud("put", {}, "", `navierasAlertas/atender/${idAlerta}/${idUsuario}`, "atenderAlertaNaviera");
  };

  // Función CRUD simplificada
  const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    //console.log(`Ejecutando ${metodo} en ${catalogo} para ${stateVar}`);
    
    return Crud_Catalogos(catalogo, "", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        //console.log(`Resultado de ${stateVar}:`, returnVal); // Depuración
        
        switch (metodo) {
          case "get": 
            if (stateVar === "listaAlertasMovimientoAlertaCategoria") {
              if (Array.isArray(returnVal)) {
                //console.log(`Alertas encontradas: ${returnVal.length}`);
                setListaAlertas(returnVal);
              } else {
                //console.log("No se encontraron alertas o no es un array");
                setListaAlertas([]);
              }
              setLoading(false);
            }
            break; 
            
          case "put":
            if (stateVar === "atenderAlertaNaviera") {
              //console.log("Alerta atendida, actualizando lista");// Llamar al callback si existe
              if (typeof onAlertaAtendida === 'function') {
                //console.log("Notificando a componentes padres sobre alerta atendida");
                onAlertaAtendida(categoria);
              }
              
              // Actualizar también esta lista
              listar();
            }
            break;
            
          default:
            break;
        }
      })
      .catch(err => { 
        console.error("Error en operación CRUD:", err); 
        setLoading(false);
        setMostrarMensaje(true);
      });
  };

  // Cargar datos cuando cambian dependencias importantes
  useEffect(() => {
    //console.log("Ejecutando useEffect con dependencias", { idmovimiento, categoria, idusuario });
    
    if (idmovimiento && categoria) {
      //console.log("Llamando a listar() desde useEffect");
      listar();
    } else {
      //console.warn("Falta información necesaria:", { idmovimiento, categoria, idusuario });
      setLoading(false);
      setMostrarMensaje(true);
    }
  }, [idmovimiento, categoria, idusuario]);

  // Mostrar mensaje después de un tiempo si no hay resultados
  useEffect(() => {
    let timer;
    
    if (listaAlertas.length === 0 && !loading) {
      //console.log("No hay alertas, configurando timer para mostrar mensaje");
      timer = setTimeout(() => {
        setMostrarMensaje(true);
      }, 2000);
    } else {
      setMostrarMensaje(false);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [listaAlertas, loading]);

  // Obtener color según categoría
  const getCategoryColor = () => {
    const colors = {
      "Desvío de ruta": "danger",
      "GPS sin señal": "warning",
      "Unidad detenida": "info"
    };
    return colors[categoria] || "primary";
  };

  //console.log("Estado actual:", { 
  //  listaAlertas: listaAlertas.length, 
  //  loading, 
  //  mostrarMensaje 
  //}); // Depuración

  // Estado de carga
  if (loading) {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="loader"></div>
        <span className="ml-3">Cargando alertas...</span>
      </div>
    );
  }

  return (
    <>
      {listaAlertas.length > 0 ? (
        <Card>
          <Card.Header>
            <h4 className={`text-${getCategoryColor()} mb-0`}>
              Alertas de {categoria} - Movimiento {idmovimiento}
            </h4>
          </Card.Header>
          
          <Card.Body className="p-0">
            <TablePageable
              title={""}
              lista={listaAlertas}
              columnas={[
                {columna: "id_alerta", label: "Id Alerta"},
                {columna: "id_movimiento", label: "Id Movimiento"},
                {columna: "trigger_name", label: "Tipo Alerta"},
                {columna: "alerta_categoria", label: "Alerta Categoria"},
                {columna: "fecha_registro", label: "Fecha Alerta"},
                {columna: "atendida", label: "Atender",
                  form: (row) => {
                    if(row.atendida === null) {
                      return(
                        <Button
                          pill
                          size="sm"
                          outline
                          color="primary"
                          onClick={() => atenderAlertaNaviera(row.id_alerta, idusuario)}                                
                        >
                        <i className="fe fe-bell"></i>
                        </Button>
                      );    
                    } else {
                      return <span className="badge badge-success">Atendida</span>;
                    }                                
                  }
                },
                {columna: "detalle", label: "Detalle",
                  form: (row) => {
                    return(
                      <ModalLayout
                        tamanio={"60%"}
                        title="Detalle de la Alerta"
                        name={
                          <Button pill size="sm" outline color="info">
                            <i className="fe fe-eye"></i>
                          </Button>
                        }
                        formulario={<DetalleAlerta
                          idAlerta={row.id_alerta}
                          esquema={"naviera"} 
                        />}
                        hiddenModal={""}
                        Fclose={() => {}}
                      /> 
                    );   
                  }
                },
                {columna: "ubicacion", label: "Ubicación",
                  form: (row) => {
                    return(
                      <Button
                        pill
                        size="sm"
                        outline
                        color="success"
                        onClick={() =>
                          window.open(
                            "https://maps.google.com/?q=" +
                            row.latitud + "," + row.longitud +
                            "&t=m",
                            "mapa_alerta",
                            "width=900,height=600,scrollbars=NO"
                          )
                        }
                        disabled={!row.latitud || !row.longitud}
                      >
                        <i className="fe fe-map-pin"></i>
                      </Button>
                    ); 
                  }                               
                }
              ]}
              id="id_alerta"
              paginacion={true}
              elementosPorPagina={15}
            />
          </Card.Body>
        </Card>
      ) : (
        mostrarMensaje && (
          <Alert type="primary" icon="info-circle">
            <h4>Sin alertas</h4>
            <p>No hay alertas de {categoria} para el movimiento {idmovimiento}</p>
            <div className="mt-2">
              <Button color="primary" size="sm" onClick={listar}>
                <i className="fe fe-refresh-cw mr-1"></i>
                Intentar nuevamente
              </Button>
            </div>
          </Alert>
        )
      )}
    </>
  );
};

export default ListarAlertasPorCategoriaDeMovimiento;